import { TypographyRebrand } from 'src/components/atoms/TypographyRebrand'
import {
  ExampleCardRebrand,
  ExampleCardRebrandProps,
  ExampleType
} from 'src/components/molecules/ExampleCardRebrand'

const CALCULATOR_LINK =
  'https://www.tanestrees.org.nz/resource-centre/carbon-calculator'

const EXAMPLES: ExampleCardRebrandProps[] = [
  {
    title: 'A return flight from Auckland to Wellington',
    numTrees: 1,
    type: ExampleType.Flight
  },
  {
    title: 'A return flight from Christchurch to Auckland',
    numTrees: 2,
    type: ExampleType.Flight
  },
  {
    title: 'A return flight from Queenstown to Wellington',
    numTrees: 1,
    type: ExampleType.Flight
  },
  {
    title: 'A return flight from Auckland to Sydney',
    numTrees: 4,
    type: ExampleType.Flight
  },
  {
    title: 'A return flight from Auckland to London',
    numTrees: 34,
    type: ExampleType.Flight
  },
  {
    title: 'Use of medium-sized car, 10,000 km',
    numTrees: 9,
    type: ExampleType.Driving
  },
  {
    title: 'Household electricity use for 1 year (8,000 kWh)',
    numTrees: 3,
    type: ExampleType.Utilities
  },
  {
    title: 'Avg household of 2 adults & 2 children emissions per year',
    numTrees: 32,
    type: ExampleType.Household
  }
]

// "Common scenarios you could try" section of /native-trees-carbon-calculator.
const CarbonScenariosSectionRebrand = () => (
  <section className='bg-linen' id='examples'>
    <div className='container mx-auto flex flex-col gap-6 px-4 py-12 lg:px-20'>
      <h2 className='font-display-rebrand text-[25px] md:text-5xl font-extrabold leading-[100%] mt-0 mb-4 text-forestDeep'>
        Common scenarios you could try
      </h2>
      <TypographyRebrand variant='introduction' color='forestDeep'>
        Below are some common examples of the number of native trees you would
        need to plant to mitigate your CO₂ emissions from today over 50 years.
      </TypographyRebrand>
      <div className='grid grid-cols-1 items-stretch gap-5 md:grid-cols-2 lg:grid-cols-4'>
        {EXAMPLES.map(example => (
          <ExampleCardRebrand key={example.title} {...example} />
        ))}
      </div>
      <TypographyRebrand variant='paragraph' color='forestDeep'>
        You can find more examples on the{' '}
        <a
          href={CALCULATOR_LINK}
          target='_blank'
          rel='noreferrer'
          className='text-forestDeep underline underline-offset-2 hover:opacity-80'
        >
          Tāne&apos;s Tree Trust calculator
        </a>
        .
      </TypographyRebrand>
    </div>
  </section>
)

export default CarbonScenariosSectionRebrand
